import { render, staticRenderFns } from "./prism-editor.vue?vue&type=template&id=df9b686a&scoped=true"
import script from "./prism-editor.vue?vue&type=script&lang=js"
export * from "./prism-editor.vue?vue&type=script&lang=js"
import style0 from "./prism-editor.vue?vue&type=style&index=0&id=df9b686a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b686a",
  null
  
)

export default component.exports